(() => {
  const productRoot = document.querySelector('[data-main-stable-media]');
  if (!productRoot) return;

  let embeddedProductData;

  const getEmbeddedProductData = () => {
    if (embeddedProductData) return embeddedProductData;

    const productDataNode = productRoot.querySelector('#productData[type="application/json"]');
    if (!productDataNode) return null;

    try {
      embeddedProductData = JSON.parse(productDataNode.textContent);
      return embeddedProductData;
    } catch (error) {
      console.error('Unable to parse embedded product data.', error);
      return null;
    }
  };

  const useEmbeddedProductData = (elementName) => {
    const Gallery = customElements.get(elementName);
    if (!Gallery || Gallery.prototype.mainEmbeddedProductDataEnabled) return;

    const originalGetProductJson = Gallery.prototype.getProductJson;

    Gallery.prototype.getProductJson = function (productUrl) {
      if (this.closest('[data-main-stable-media]')) {
        const productData = getEmbeddedProductData();
        if (productData) return Promise.resolve(productData);
      }

      return originalGetProductJson.call(this, productUrl);
    };

    Gallery.prototype.mainEmbeddedProductDataEnabled = true;
  };

  useEmbeddedProductData('media-gallery');
  useEmbeddedProductData('media-gallery-mobile');

  const desktopQuery = window.matchMedia('(min-width: 768px)');

  const mountGallery = (desktop) => {
    const selector = desktop ? '[data-main-media-desktop]' : '[data-main-media-mobile]';
    const holder = productRoot.querySelector(selector);
    const template = holder && holder.querySelector('[data-main-media-template]');

    if (!holder || !template || holder.dataset.mainMediaMounted === 'true') return;

    template.before(template.content.cloneNode(true));
    holder.dataset.mainMediaMounted = 'true';
  };

  mountGallery(desktopQuery.matches);

  const handleViewportChange = (event) => mountGallery(event.matches);
  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', handleViewportChange);
  } else {
    desktopQuery.addListener(handleViewportChange);
  }
})();
